import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Destinations from "@/components/Destinations";
import Services from "@/components/Services";
import AlphaGuide from "@/components/AlphaGuide";
import AppSection from "@/components/AppSection";
import Trust from "@/components/Trust";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Destinations />
      <Services />
      <AlphaGuide />
      <AppSection />
      <Trust />
      <Footer />
    </main>
  );
}
